"use client";

import { useLocale } from "next-intl";
import { Link } from "@/i18n/navigation";
import { trackGizmo } from "@/lib/analytics";

export default function ColorNextSteps({ source }: { source: "undertone" | "draping" | "chart" }) {
  const locale = useLocale();
  if (locale !== "en") return null;
  const copy = {
    undertone: ["Put your undertone comparison to use", "Compare warm, cool and neutral directions on a photo. Keep the shades you like instead of treating the quiz as a rule."],
    draping: ["Try the colors in your next look", "After comparing clothing colors, see how a hair or makeup shade changes the whole combination."],
    chart: ["Turn a palette into a color you can try", "Use the season chart as a starting point, then compare actual shade directions on your photo."],
  }[source];
  return <section style={{ borderTop: "1px solid #e2e8f0", marginTop: 32, paddingTop: 24 }}>
    <h2 style={{ fontSize: "1.4rem", fontWeight: 600, margin: "0 0 12px" }}>{copy[0]}</h2><p style={{ lineHeight: 1.7 }}>{copy[1]}</p>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "12px 24px", marginTop: 16 }}>
      {[
        [source === "undertone" ? "/best-hair-colors-for-skin-tone" : "/ai-hair-color-try-on", source === "undertone" ? "Choose hair colors for your undertone" : "Try a hair color on your photo"],
        ["/what-color-lipstick-should-i-wear", "Compare lipstick shades"],
        ["/what-color-blush-should-i-wear", "Compare blush colors"],
      ].map(([href, text]) => <Link key={href} href={href} style={{ color: "#92204c", paddingBlock: 6 }} onClick={() => trackGizmo("color_tool_next", { source, destination: href })}>{text} →</Link>)}
    </div>
  </section>;
}
